<template>
    <section class="responsiveSection margin-vertical-60 margin-vertical-s-30">
        <div class="responsiveSection__grid">
            <h2 class="sectionRooftitle">
                {{ trans('NEWS_ARCHIVE_ROOFTITLE') }}
            </h2>
            <h1 class="sectionHeadline">
                {{ trans('NEWS_ARCHIVE_HEADLINE') }}
            </h1>
            <div class="width100 margin-top-10">
                <div class="showMobile pos-relative">
                    <span
                        class="fa fa-search pos-absolute pos-right-10 pos-top-10"
                        aria-hidden="true">
                    </span>
                    <label>
                        <span class="sr-only">{{ trans('NEWS_ARCHIVE_SEARCH_PLACEHOLDER') }}</span>
                        <input
                            v-model="searchTerm"
                            class="formSearchbar__textfield--withIcon"
                            type="text"
                            value=""
                            autocomplete="off"
                            :placeholder="trans('NEWS_ARCHIVE_SEARCH_PLACEHOLDER')"
                            maxlength="1024">
                    </label>
                    <div
                        v-if="locale === 'de'"
                        class="flex flex--directionColumn">
                        <label class="margin-top-5 form_row__checkbox">
                            <input
                                v-model="checkedLocales"
                                type="checkbox"
                                name="de"
                                value="de">
                            {{ trans('NEWS_ARCHIVE_SEARCH_FILTER_1') }}
                        </label>
                        <label class="form_row__checkbox">
                            <input
                                v-model="checkedLocales"
                                type="checkbox"
                                name="en"
                                value="en">
                            {{ trans('NEWS_ARCHIVE_SEARCH_FILTER_2') }}
                        </label>
                    </div>
                </div>
                <div class="width66">
                    <news
                        v-model="page"
                        :items="newsFeeds"
                        :search="searchTerm"
                        :locales="checkedLocales"
                        :items-per-page="15"
                        :init-page="page" />
                </div>
                <aside class="width33 aside padding-left-20 padding-left-s-0">
                    <div class="hideMobile pos-relative">
                        <span class="fa fa-search pos-absolute pos-right-10 pos-top-10"></span>
                        <label>
                            <span class="sr-only">{{ trans('NEWS_ARCHIVE_SEARCH_PLACEHOLDER') }}</span>
                            <input
                                v-model="searchTerm"
                                class="formSearchbar__textfield--withIcon"
                                type="text"
                                value=""
                                autocomplete="off"
                                :placeholder="trans('NEWS_ARCHIVE_SEARCH_PLACEHOLDER')"
                                maxlength="1024">
                        </label>
                        <div
                            v-if="locale === 'de'"
                            class="flex flex--directionColumn">
                            <label class="margin-top-5 form_row__checkbox">
                                <input
                                    v-model="checkedLocales"
                                    type="checkbox"
                                    name="de"
                                    value="de">
                                {{ trans('NEWS_ARCHIVE_SEARCH_FILTER_1') }}
                            </label>
                            <label class="form_row__checkbox">
                                <input
                                    v-model="checkedLocales"
                                    type="checkbox"
                                    name="en"
                                    value="en">
                                {{ trans('NEWS_ARCHIVE_SEARCH_FILTER_2') }}
                            </label>
                        </div>
                    </div>
                    <div v-if="locale === ('de'||'en')">
                        <div class="hl-module margin-top-60 margin-top-s-0">
                            {{ trans('NEWS_ARCHIVE_RELEASE_CALENDAR_HEADLINE') }}
                        </div>
                        <p v-html="trans('NEWS_ARCHIVE_RELEASE_CALENDAR_TEXT').replace('{path}', paths.releases)"></p>
                    </div>
                    <div>
                        <div class="hl-module margin-top-60 margin-top-s-20">
                            {{ trans('NEWS_ARCHIVE_NEWSLETTER_HEADLINE') }}
                        </div>
                        <p v-html="trans('NEWS_ARCHIVE_NEWSLETTER_TEXT').replace('{press-path}', `${ paths.press }#pressnewsletterForm`).replace('{info-path}', paths.infographics_all)"></p>
                        <ul class="flex margin-top-10 width100">
                            <li
                                v-for="(socialMedia, index) in socialMediaLinks"
                                :key="socialMedia.name"
                                class="flex__item"
                                :class="{ 'margin-left-10': index > 0 }">
                                <a
                                    class="button"
                                    :class="`button--${ socialMedia.name }`"
                                    :href="socialMedia.link"
                                    :aria-label="`Social Media: ${ socialMedia.name }`"
                                    target="_blank"
                                    rel="noopener"
                                    :data-gtm="`social__${ socialMedia.name.toLowerCase() }`">
                                    <i
                                        class="fa"
                                        :class="`fa-${ socialMedia.name }`"
                                        aria-hidden="true">
                                    </i>
                                </a>
                            </li>
                            <li
                                v-if="locale === 'de'"
                                class="flex__item">
                                <a
                                    class="button button--xing margin-left-10"
                                    :href="trans('SOCIAL_XING')"
                                    aria-label="Social Media: XING"
                                    target="_blank"
                                    rel="noopener"
                                    data-gtm="social__xing">
                                    <i
                                        class="fa fa-xing"
                                        aria-hidden="true">
                                    </i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </aside>
            </div>
        </div>
    </section>
</template>

<script>
    import News from './news';
    import Translator from 'tools/trans';
    import qs from 'qs';

    export default {
        components: {
            'news': News,
        },
        props: {
            newsFeeds: { type: Array, required: true },
            paths: { type: Object, required: true },
        },
        data() {
            return {
                socialMediaLinks: [
                    { name: 'facebook', link: Translator.trans('SOCIAL_FACEBOOK') },
                    { name: 'twitter', link: Translator.trans('SOCIAL_TWITTER') },
                    { name: 'linkedin', link: Translator.trans('SOCIAL_LINKEDIN') },
                    { name: 'instagram', link: Translator.trans('SOCIAL_INSTAGRAM') },
                ],
                searchTerm: '',
                page: 1,
                locale: window.stGlobals.locale,
                checkedLocales: [window.stGlobals.locale],
            };
        },
        watch: {
            page() {
                this.updateURL();
            },
            searchTerm() {
                this.updateURL();
            },
            checkedLocales() {
                this.updateURL();
            },
        },
        methods: {
            trans: Translator.trans,
            getQueryString() {
                const query = window.location.search.substring(1);
                const queryParams = qs.parse(query);

                if ('search' in queryParams) {
                    this.searchTerm = queryParams['search'];
                }
                if ('international' in queryParams && queryParams['international'] === 'true') {
                    this.checkedLocales = [window.stGlobals.locale, 'en'];
                }
                if ('page' in queryParams) {
                    this.page = Number(queryParams['page']);
                }
            },
            replaceState(hash) {
                if (history.replaceState) {
                    const newState = hash !== '' ? hash : location.pathname;
                    history.replaceState(null, null, newState);
                } else {
                    location.hash = hash;
                }
            },
            updateURL() {
                const params = {};
                if (this.page && this.page !== 1) {
                    params.page = this.page;
                }
                if (this.searchTerm) {
                    params.search = this.searchTerm;
                }
                if (this.checkedLocales.includes('en')) {
                    params.international = 'true';
                }
                const queryString = qs.stringify(params, { addQueryPrefix: true });

                this.replaceState(queryString);
            },
        },
        created() {
            this.getQueryString();
        },
    };
</script>
